<template>
  <div class="my-center">
    <div class="my-top">
      <img
        :src="head_pic != '' && head_pic != null ? head_pic : default_icon"
        class="avatar_icon"
        alt=""
      />
      <div>
        <div class="size1">{{ nickname }}</div>
      </div>
    </div>
    <div class="my-bill">
      <div class="bill-box">
        <div class="size3">{{ billData.wait }}</div>
        <div class="size5">待退还消费金</div>
        <div class="box-layout1">
          <div class="box-layout2">
            <div class="size4">{{ billData.complete }}</div>
            <div class="size5">已退还消费金</div>
          </div>
          <div class="bill_btn" @click="jumpBill">退还账单</div>
        </div>
      </div>
    </div>
    <div class="my-box">
      <div class="my-item" @click="jumpUrl(0)">
        <img
          src="@/assets/third/guide/guide_tab_icon1.png"
          class="guide-icon"
          alt=""
        />
        <div>集采经纪人</div>
        <img
          src="@/assets/third/guide/my_go.png"
          class="guide-go-icon"
          alt=""
        />
      </div>
      <div class="my-item" v-if="showSupplier" @click="jumpUrl(1)">
        <img
          src="@/assets/third/guide/guide_tab_icon2.png"
          class="guide-icon"
          alt=""
        />
        <div class="flex-item">
          <div>集采供应方</div>
          <span class="number-point" v-if="msgNum != 0">{{ msgNum }}</span>
        </div>
        <img
          src="@/assets/third/guide/my_go.png"
          class="guide-go-icon"
          alt=""
        />
      </div>
    </div>
    <van-dialog
      v-model="showPersonal"
      :show-cancel-button="false"
      width="300"
      :showConfirmButton="false"
    >
      <div class="per-title">实名认证提示</div>
      <div class="per-content">
        为保护您的账号安全，并确认用户账号为本人持有，请先进行实名认证。
      </div>
      <div class="per-box">
        <span @click="showPersonal = false">取消</span>
        <span @click="goPersonal">认证</span>
      </div>
    </van-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      billData: {
        complete: "0.00",
        wait: "0.00",
      },
      token: "",
      memberInfo: {},
      head_pic: "",
      default_icon: require("@/assets/third/guide/avatar.png"),
      nickname: "",
      showSupplier: false,
      msgNum: 0,
      showPersonal: false,
    };
  },
  created() {
    this.token = localStorage.getItem("_token") || this.$route.query.token;
    let msgNum = this.$route.query.msgNum;
    if (this.token) {
      this.getBillInfo();
    }
    if (msgNum) {
      this.msgNum = msgNum;
    }
  },
  methods: {
    jumpBill() {
      this.params("", "", "threeYearBill"); //账单
    },
    jumpUrl(type) {
      if (type == 0) {
        let _this = this;
        this.$api.get("member/member/member/auth/detail").then((res) => {
          if (res) {
            if (res.status == 2) {
              //已实名认证
              try {
                _this.params("", "", "collectBroker"); //经纪人
              } catch (err) {
                _this.$dialog
                  .alert({
                    message:
                      "尊敬的集采经纪人，集采供应方，为了功能的正常使用，请自行去应用商城升级到最新版本，谢谢您的配合！",
                    confirmButtonText: "确定",
                    className: "dialog",
                  })
                  .then(() => {});
              }
            } else {
              _this.showPersonal = true;
            }
          }
        });
      } else if (type == 1) {
        try {
          this.params("", "", "collectSupplier"); //供应方
        } catch (err) {
          this.$dialog
            .alert({
              message:
                "尊敬的集采经纪人，集采供应方，为了功能的正常使用，请自行去应用商城升级到最新版本，谢谢您的配合！",
              confirmButtonText: "确定",
              className: "dialog",
            })
            .then(() => {});
        }
      }
    },
    goPersonal() {
      this.showPersonal = false;
      this.params("", "", "personal");
    },
    getBillInfo() {
      if (!this.token) {
        return;
      }
      this.$api
        .post("member-relation/member/three/year/supplier/supplier-icon-show")
        .then((res) => {
          if (res) {
            this.showSupplier = res.status != 0;
            this.$emit("showSupplier", this.showSupplier);
          }
        });
      this.$api.get("member/member/user/detail").then((res) => {
        if (res) {
          this.head_pic = res.infos.head_pic;
          this.nickname = res.nickname;
        }
      });
      this.$api.post("onorder/member/order/refund-of-bills").then((res) => {
        if (res) {
          this.billData.complete = res.complete;
          this.billData.wait = res.wait;
        }
      });
    },
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );

    window.onresize = () => {
      document.documentElement.style.setProperty(
        "font-size",
        (document.body.clientWidth / 375) * 10 + "px"
      );
    };
  },
};
</script>
<style lang="less" scoped>
.my-center {
  background: #ffffff;
  height: 100%;
}
.my-top {
  padding: 0 2.2rem 1.6rem 2.2rem;
  display: flex;
  align-items: center;
  padding-top: calc(2rem + var(--status-height));
  & > div {
    flex: 1;
    overflow: hidden;
    .size1 {
      color: #333333;
      font-size: 1.6rem;
    }
    & > div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }
  }
}
.avatar_icon {
  width: 5.2rem;
  height: 5.2rem;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 1.5rem;
}
.my-bill {
  background: url("~@/assets/third/guide/my_bg.png") center 0.8rem no-repeat;
  background-size: 100% 100%;
  margin: 0 1.2rem 0 1.2rem;
  height: 17.8rem;
  padding: 0.9rem 0 0 0;
  .bill-box {
    padding: 1.8rem 3rem;
    color: #ffffff;
    .size3 {
      font-size: 3.2rem;
    }
    .size4 {
      font-size: 1.4rem;
      margin-bottom: 0.4rem;
    }
    .size5 {
      font-size: 1.4rem;
      color: rgba(255, 255, 255, 0.88);
    }
    .box-layout1 {
      margin-top: 2.2rem;
      display: flex;
      align-items: center;
    }
    .bill_btn {
      height: 3.4rem;
      border-radius: 1.7rem;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0rem 0.2rem 0.6rem 0rem rgba(254, 143, 0, 1);
      margin-top: 0.3rem;
      width: 8.4rem;
      text-align: center;
      line-height: 3.4rem;
      font-size: 1.4rem;
      font-weight: bold;
      color: #fa6d13;
    }
    .box-layout2 {
      flex: 1;
    }
  }
}
.guide-icon {
  width: 2.4rem;
  height: 2.4rem;
}
.guide-go-icon {
  width: 1.3rem;
  height: 1.3rem;
}
.my-item {
  margin: 0 0.9rem;
  padding: 1.4rem 0;
  display: flex;
  align-items: center;
  & > div {
    margin-left: 1.2rem;
    flex: 1;
    font-size: 1.4rem;
    color: #333333;
    font-weight: bold;
  }
  .flex-item {
    display: inline-flex;
    align-items: center;
    & > div {
      flex: 1;
    }
  }
  .number-point {
    background: #ff3c3c;
    display: inline-block;
    color: #fff;
    height: 1.875rem;
    line-height: 1.9rem;
    border-radius: 1.375rem;
    font-size: 1.25rem;
    font-weight: lighter;
    transform: scale(0.8);
    padding: 0 0.6rem;
    border: 0.375rem solid #ffcbcb;
    margin-right: 1rem;
  }
}
.my-box {
  margin: 0 1.2rem;
  position: relative;
}
.per-title {
  color: #333333;
  text-align: center;
  font-size: 1.8rem;
  font-weight: 600;
  padding: 2.1rem 0 1.5rem 0;
}
.per-content {
  font-size: 1.5rem;
  color: #333333;
  padding: 0 1.7rem;
}
.per-box {
  padding: 3rem 0 2rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  & > span {
    width: 9.6rem;
    height: 3.4rem;
    display: inline-flex;
    border-radius: 1.8rem;
    justify-content: center;
    line-height: 3.4rem;
    font-size: 1.6rem;
  }
  & > span:nth-of-type(1) {
    border: 1px solid #e5e5e5;
    color: #666666;
    box-sizing: border-box;
  }
  & > span:nth-of-type(2) {
    background: #ff5f2e;
    color: #fff;
    margin-left: 2.6rem;
  }
}
.dialog {
  .van-dialog__content {
    color: #333333;
    font-size: 14px;
    line-height: 23px;
  }
}
</style>
